'use strict';

module.exports = text;

/* Stringify text.
 * Supports named entities in `settings.encode: true` mode:
 *
 *     AT&amp;T
 *
 * Supports numbered entities in `settings.encode: numbers`
 * mode:
 *
 *     AT&#x26;T
 */
function text(node, parent) {
  return this.encode(this.escape(node.value, node, parent), node);
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/text.js
// module id = 982
// module chunks = 95715928098905 168707334958949